// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Kln4","messages":"Chat_messages__3zi8u","dateDivider":"Chat_dateDivider__3vJBT"};